import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstimatesService {
  constructor(private http: HttpClient) {}

  getEstimateData(data: object) {
    return this.http.post(`${environment().api}/car/get/estimates`, data);
  }

  getEstimateDataAll(data: object) {
    return this.http.post(`${environment().api}/car/get/all/estimates`, data);
    // return this.http.post(`${environment().api}/car/check/alert`, data);
  }

  setEstimateData(data: object) {
    return this.http.post(`${environment().api}/car/add/estimates`, data);
  }

  vehicleEstimates(data: object) {
    return this.http.post(`${environment().api}/car/get/vehicle-estimates`, data);
  }

  adminAlert(data: object) {
    return this.http.post(`${environment().api}/car/alert/admin`, data);
  }

  checkAlert(data: object) {
    return this.http.post(`${environment().api}/car/check/alert`, data);
  }

  purchaseApproval(data: object) {
    // return this.http.post(`${environment().api}/car/update/alert`, data);
    return this.http.post(`${environment().api}/car/update/purchaseApproval`, data);
  }
  salesupdateAlert(data: object) {
    return this.http.post(`${environment().api}/car/update/salesApproval`, data);
  }

  purchaseTypeList() {
    return this.http.get(`${environment().api}/settings/information/get/purchase-type`);
  }
}
